/* Lorelia Seiten neu: weiches Hereingleiten + Zähler (Inhalt ist ohne JS sichtbar) */
(function(){
  if (window.__lrsGeladen) return; window.__lrsGeladen = true;
  var ruhig = matchMedia('(prefers-reduced-motion: reduce)').matches;
  var alle = [].slice.call(document.querySelectorAll('[data-lrs] .lrs-gleit'));
  var zaehler = [].slice.call(document.querySelectorAll('[data-lrs] [data-zaehle]'));
  alle.forEach(function(el){
    if (ruhig) return;
    if (el.getBoundingClientRect().top > innerHeight) {
      el.classList.add('warte');
      var n = el.parentElement ? [].indexOf.call(el.parentElement.children, el) : 0;
      el.style.transitionDelay = Math.min(n, 5) * 80 + 'ms';
    }
  });
  var zaehle = function(el){
    if (el.dataset.fertig) return; el.dataset.fertig = 1;
    var ziel = +el.getAttribute('data-zaehle'), t0 = null;
    if (ruhig) return;
    var s = function(ts){ if (!t0) t0 = ts; var p = Math.min(1, (ts - t0) / 1300); el.textContent = Math.round(ziel * (1 - Math.pow(1 - p, 3))); if (p < 1) requestAnimationFrame(s); };
    requestAnimationFrame(s);
  };
  var pruefe = function(){
    alle.forEach(function(el){ if (el.classList.contains('warte') && el.getBoundingClientRect().top < innerHeight * .92) el.classList.remove('warte'); });
    zaehler.forEach(function(el){ var r = el.getBoundingClientRect(); if (r.top < innerHeight && r.bottom > 0) zaehle(el); });
  };
  addEventListener('scroll', pruefe, { passive: true, capture: true });
  addEventListener('resize', pruefe);
  pruefe(); setTimeout(pruefe, 600);
  setTimeout(function(){ alle.forEach(function(el){ if (el.getBoundingClientRect().top < innerHeight) el.classList.remove('warte'); }); }, 3500);
})();
